export default __webpack_public_path__ + "static/media/logo.63df57cc.png";